import styled from 'styled-components';
import { motion } from 'framer-motion';
import { scrollBlueStyles } from '../../../styles/sharedStyles';

export const StyledTrainingsInformations = styled(motion.div)`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding-right: 40px;
    max-height: 90%;
    overflow-y: scroll;

    ${scrollBlueStyles};

    @media only screen and (max-width: 767px) {
        padding-bottom: 40px;
        max-height: unset;
        height: auto;
        overflow-y: visible;
        align-items: center;
        padding-right: 0;
    }
`;
